// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3P8oF","noInteraction":"EventWrapper_noInteraction__37AEc"};